// NPM imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NumberInput, Tooltip, Button } from "../../../revvComponents";

import FormField from "../PricebookItemEditor/FormField";
import PriceMatrixRow from "../../PriceMatrixRow";
import PricingPreview from "../../PricingPreview";

// Actions Imports
import PricebooksActions from "../../../actions/PricebooksActions";

// Internal Imports
import { GRID } from "../../../constants";

// Destructuring
const { updatePricingMethodData } = PricebooksActions;
const { PRICEBOOK_COLUMNS, PRICING_METHODS } = GRID;

// Declarations

class PriceMatrixEditor extends Component {
  _updateState = newState => {
    this.props.updatePricingMethodData("matrix", newState);
  };

  _onBasePriceChange = value => {
    this._updateState({ basePrice: value });
  };

  _onValueChange = (index, key, value, min) => {
    const cloneRange = [...this.props.data.range];
    cloneRange[index][key] = value;
    if (value <= min && value !== "") {
      this._updateState({
        errMsg: `Enter a value greater than ${min}`,
      });
    } else {
      this._updateState({ errMsg: "", range: cloneRange });
    }
  };

  _onAddRange = e => {
    e.preventDefault();
    const { range } = this.props.data;
    const lastRangeEntry = range[range.length - 1];
    if (lastRangeEntry.max > lastRangeEntry.min) {
      const obj = {
        min: range[range.length - 1].max + 1,
        max: "",
        value: "",
      };
      const newRange = range.concat(obj);
      return this._updateState({ errMsg: "", range: newRange });
    }
    return this._updateState({
      errMsg: `Enter a value greater than ${lastRangeEntry.min}`,
    });
  };

  _deleteLastEntry = () => {
    const { range } = this.props.data;
    const cloneRange = [...range];
    cloneRange.pop();
    this._updateState({ errMsg: "", range: cloneRange });
  };

  _isBtnDisabled = () => {
    const { range } = this.props.data;
    let isDisabled = true;
    if (
      range.length !== 0 &&
      range[range.length - 1].max !== "" &&
      range[range.length - 1].value !== ""
    ) {
      isDisabled = false;
    }
    return isDisabled;
  };

  render() {
    const { basePrice, errMsg, range } = this.props.data;
    const {
      currencySymbol,
      formRowData,
      fieldMapIndex,
      customMatrixFields,
      type,
    } = this.props;
    const uom = formRowData[fieldMapIndex[PRICEBOOK_COLUMNS.QUANTITY_UOM]];

    return (
      <div className="pricematrixeditor-wrapper">
        <section>
          <div className="bundleeditor-baseprice-wrapper">
            <div className="pricing-options-matrixtitle">
              Base Price
              <Tooltip
                placement="top"
                align={{
                  offset: [0, 4],
                }}
                overlay="This field can be used to add platform fee or base price of any other kind. The total value will have this price added.">
                <span className="whats-this">
                  <FontAwesomeIcon icon={["far", "question-circle"]} />
                </span>
              </Tooltip>
            </div>
            <NumberInput
              className="pricing-options-price"
              inpCurrencySymbol={currencySymbol}
              isCurrency
              isFloat
              onChange={this._onBasePriceChange}
              placeholder="Enter Base Price"
              value={basePrice}
              data-test="pricematrixeditor-number-input"
            />
            <div className="pricing-options-uomtitle">
              {customMatrixFields.map(fields => (
                <FormField
                  {...fields}
                  isEdit={this.props.isEdit}
                  key={fields.fld}
                />
              ))}
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="pricing-options-matrixtitle col-md-8">
              Range (in number of {uom || "-"})
            </div>
            <div className="pricing-options-matrixtitle-price col-md-4">
              {type === PRICING_METHODS.STEP_TIER_PRICING
                ? "Price per range"
                : "Price per unit"}
            </div>
          </div>
          <div>
            {range.map((value, index) => (
              <PriceMatrixRow
                currencySymbol={currencySymbol}
                data={value}
                deleteLastEntry={this._deleteLastEntry}
                index={index}
                key={value.min}
                onChange={this._onValueChange}
                totalEntries={range.length - 1}
                data-test="pricematrixeditor-pricematrixrow"
              />
            ))}
          </div>
          <div>
            {errMsg && (
              <div className="error-message-wrapper">
                <span className="error-message-icon">
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </span>
                {errMsg}
              </div>
            )}
            <Button
              className="revv-btn-secondary"
              disabled={this._isBtnDisabled()}
              onClick={this._onAddRange}
              data-test="pricematrixeditor-addrange-btn">
              Add Range
            </Button>
          </div>
        </section>
        <section>
          <PricingPreview
            currencySymbol={currencySymbol}
            data={{ ...this.props.data, ...{ type: this.props.type } }} // PricingPreview Component Needs Selected Pricing Type
            readOnly
          />
        </section>
      </div>
    );
  }
}

const mapStateToProps = store => {
  const { formRowData, metaData: { fieldMapIndex } = {} } =
    store.PricebookStore;
  const { matrix: data, view } = store.PricebookStore.pricingMethodData;
  return {
    data,
    fieldMapIndex,
    formRowData,
    view,
  };
};

const mapDispatchToProps = {
  updatePricingMethodData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceMatrixEditor);
